import { AppAreaConfig } from '@/funnels/@types'
import walkingMale from './activity-male-walking'
import walkingOutdoorFemale from './activity-female-walking-outdoor'

const appAreaConfig: AppAreaConfig = {
	appArea: 'main-walking-outdoor',
	landing: {
		ids: ['loader-walking-outdoor', 'age-walking-outdoor'],
		route: {
			path: '/walking-outdoor',
			name: 'main-walking-outdoor-funnel',
		},
	},
	funnel: {
		id: 'ob-walking-outdoor-gender-selection',
		route: {
			path: '/walking-outdoor/ob/:page(.*)?',
			name: 'main-walking-outdoor',
		},
		slug: 'main-walking-outdoor',
		locale: ['en', 'de-DE', 'fr-FR', 'tr', 'sv', 'pl', 'pt-BR', 'it-IT', 'es-ES', 'es-419', 'da', 'nb', 'nl', 'ja'],
		redirectTo: {
			sex: {
				male: { appArea: walkingMale },
				female: { appArea: walkingOutdoorFemale },
			},
		},
	},
}

export default appAreaConfig
